export default __webpack_public_path__ + "static/media/blazer.5c3087d8.jpg";